module.exports = __webpack_public_path__ + "img/mama.c561d49c.png";